import '@awesome.me/webawesome/dist/styles/webawesome.css';
import './styles.css';
import { setIconPath } from '@awesome.me/webawesome/dist/utilities/base-path.js';
import { initTheme } from './theme.js';

// Web Awesome would otherwise fetch icons from the Font Awesome CDN, which
// the production CSP (connect-src 'self') blocks. The icons the app uses
// live under web/public/icons/fa/<folder>/<name>.svg; add a file there
// before using a new <wa-icon name>.
setIconPath('/icons/fa');

// Apply the colour scheme before the shell renders, so there is no flash.
initTheme();

import './app-shell.js';
import { registerSW } from 'virtual:pwa-register';

// Precaches the shell and assets; a new build is picked up on the next
// load after it has installed (registerType autoUpdate).
registerSW({ immediate: true });
